import styled from "styled-components";

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
    /* backdrop-filter: blur(2px); */

    div.Overlay__card {
        width: 90%;
        max-width: 460px;
        box-sizing: border-box;
        padding: 30px 25px 25px 25px;
        border-radius: 10px;
        background: var(--card-color, #fff);
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;

        h2.Overlay__card__titulo {
            margin: 0;
            font-size: 16px;
            font-weight: 700;
            color: var(--text-color);
            text-align: center;
        }

        span.Overlay__card__paginas {
            font-size: 13px;
            font-weight: 500;
            color: var(--text-color-light);
        }

        span.Overlay__card__aviso {
            font-size: 12px;
            font-weight: 500;
            color: var(--text-color-light);
            text-align: center;
            margin-top: 5px;
        }

        div.Overlay__card__acoes {
            display: flex;
            justify-content: center;
            margin-top: 15px;
        }
    }
`;
